import AnchorLink from 'react-anchor-link-smooth-scroll'

import styles from './AboutNavigationDesktop.module.scss';

const AboutNavigation = ({onClick}) => {

    return ( 
        <>
            <div className={styles.aboutNavigation__innerContainer}>
                <div className={styles.aboutNavigation__sideLine}>
                    <div></div>
                </div>
                <div className={styles.aboutNavigation__center}>

                    <div className={styles.aboutNavigation__tab} onClick={()=>onClick(0)}>Meet the founder</div>
                    <div className={`${styles.aboutNavigation__line} ${styles.aboutNavigation__lineInBetween}`}><div></div></div>
                    <div className={styles.aboutNavigation__tab} onClick={()=>onClick(1)}>Subscription info</div>
                    <div className={`${styles.aboutNavigation__line} ${styles.aboutNavigation__lineInBetween}`}><div></div></div>
                    <div className={styles.aboutNavigation__tab} onClick={()=>onClick(2)}>Porn myths</div>
                    <div className={`${styles.aboutNavigation__line} ${styles.aboutNavigation__lineInBetween}`}><div></div></div>
                    <div className={styles.aboutNavigation__tab} onClick={()=>onClick(3)}>Testimonials</div>
                </div>
                <div className={styles.aboutNavigation__sideLine}>
                    <div></div>
                </div>

            </div>
        </>
     );
}
 
export default AboutNavigation;